import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { PartnerAccess } from '../../../features/partner/access/partner-access';

@Injectable({ providedIn: 'root' })
export class PartnerAccessAdminService {
  private readonly http = inject(HttpClient);

  private url(userId: number): string {
    return `${environment.apiUrl}/v1/user/administrative/user(${userId})/partner_access/`;
  }

  /** GET /v1/user/administrative/user({id})/partner_access/: a user's current access. Cyflare admins only. */
  get(userId: number): Observable<PartnerAccess> {
    return this.http.get<PartnerAccess>(this.url(userId));
  }

  /** PUT /v1/user/administrative/user({id})/partner_access/: grant or revoke. Sales needs Portal. */
  set(userId: number, portal: boolean, sales: boolean): Observable<PartnerAccess> {
    return this.http.put<PartnerAccess>(this.url(userId), { portal, sales });
  }
}
